import { CommonModule } from "@angular/common";
import { Component, OnInit, signal } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import {
  createObjectKey,
  CUSTOMER_STATUS,
  FUNCTION_RESULT_STATUS,
} from "@nova/common-interfaces";
import { ICustomerListModel, ICustomerOverview } from "@rfm/shared-interfaces";
import { BlockUIModule } from "ng-block-ui";
import { ConfirmationService, MenuItem, MessageService } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { IconFieldModule } from "primeng/iconfield";
import { InputIconModule } from "primeng/inputicon";
import { MenuModule } from "primeng/menu";
import { SelectButtonModule } from "primeng/selectbutton";
import { Table, TableModule } from "primeng/table";
import { TabMenuModule } from "primeng/tabmenu";
import { ToastModule } from "primeng/toast";
import { CommonComponent } from "../../../../lib/components/index.mjs";
import { BoolToTextPipe } from "../../../../lib/pipes/bool-to-text.pipe.mjs";
import { CustomerService } from "../../../shared/services/customers/customers.service.mjs";
import { SubscriptionChangePlanModal } from "../subscriptions/subscription-change-plan/subscription-change-plan.modal";
import { SubscriptionChangePriceModal } from "../subscriptions/subscription-change-price/subscription-change-price.modal";
import { MassEmailComponent } from "./mass-email/mass-email.component";

interface Column {
  field: string;
  header: string;
  type: string;
  pipe: string | undefined;
}

@Component({
  selector: "app-customers",
  standalone: true,
  imports: [
    TableModule,
    IconFieldModule,
    InputIconModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BlockUIModule,
    TabMenuModule,
    ToastModule,
    BoolToTextPipe,
    ConfirmDialogModule,
    MassEmailComponent,
    ButtonModule,
    MenuModule,
    DialogModule,
    SubscriptionChangePriceModal,
    SubscriptionChangePlanModal,
    SelectButtonModule,
  ],
  providers: [ConfirmationService, MessageService],
  templateUrl: "./customers.component.html",
  styleUrls: ["./customers.component.scss"], // Fixed typo
})
export class CustomersComponent extends CommonComponent implements OnInit {
  cols: Column[] = [];
  activeTab: any;
  customers: ICustomerListModel[] = [];
  selectedCustomers = signal<ICustomerListModel[] | undefined>(undefined);
  filtered_customers = signal<ICustomerListModel[] | undefined>(undefined);
  nettCustomers = signal<ICustomerListModel[] | undefined>(undefined);
  activeItem: ICustomerOverview | undefined;
  changePlanVisible = signal(false);
  changePriceVisible = signal(false);
  objectType = signal("customer");
  objectId = signal("");
  searchValue: string | undefined;

  tabs: MenuItem[] = [
    { label: "Active", command: () => this.setActiveTab("Active") },
    { label: "Inactive", command: () => this.setActiveTab("Inactive") },
    { label: "Lead", command: () => this.setActiveTab("Lead") },
    { label: "Suspended", command: () => this.setActiveTab("Suspended") },
    { label: "Balance", command: () => this.setActiveTab("Balance") },
    { label: "Archived", command: () => this.setActiveTab("Archived") },
  ];

  clear(table: Table) {
    table.clear();
    this.searchValue = ''
}

addCustomer() {
    this.router.navigate(["/admin/customers/new"]);
  }

  setActiveTab(label: string) {
    this.activeTab = label;

    switch (label.toLowerCase()) {
      case "active":
        this.filtered_customers.set(
          this.customers.filter((x) => x.status === CUSTOMER_STATUS.ACTIVE)
        );
        break;
      case "inactive":
        this.filtered_customers.set(
          this.customers.filter((x) => x.status === CUSTOMER_STATUS.INACTIVE)
        );
        break;
      case "lead":
        this.filtered_customers.set(
          this.customers.filter((x) => x.status === CUSTOMER_STATUS.LEAD)
        );
        break;
      case "suspended":
        this.filtered_customers.set(
          this.customers.filter((x) => x.status === CUSTOMER_STATUS.SUSPENDED)
        );
        break;
      case "balance":
        this.filtered_customers.set(
          this.customers.filter((x) => x.current_balance > 0)
        );
        break;
      case "archived":
        this.filtered_customers.set(
          this.customers.filter((x) => x.status === CUSTOMER_STATUS.ARCHIVED)
        );
        break;
    }
    this.nettCustomers.set(
      this.filtered_customers()?.filter((obj1) =>
        this.selectedCustomers()?.some((obj2) => obj1.id === obj2.id)
      )
    );

    console.log(this.nettCustomers());
  }

  selectionChanged(event: ICustomerOverview[]) {
    console.log(event);
    this.nettCustomers.set(
      this.filtered_customers()?.filter((obj1) =>
        event.some((obj2) => obj1.id === obj2.id)
      )
    );

    console.log(this.nettCustomers());
  }

  filter(event:any, table: Table)
  {
    table.filterGlobal(event.target.value, 'contains');
  }
  dialogVisible = signal(false);

  value: string = "off";

  changeVisibility(state: boolean) {
    this.dialogVisible.set(state);
  }

  sendEmail() {
    console.log("CUSTOMERS", this.selectedCustomers);
    this.dialogVisible.set(true);
  }
  row_items: MenuItem[] = [];
  items: MenuItem[] = [
    {
      label: "View",
      icon: "pi pi-file",
      command: () => this.view(this.activeItem!.id),
    },
    {
      label: "Edit",
      id: "edit",
      icon: "pi pi-file-edit",
      command: () => this.edit(this.activeItem!.id),
    },
    {
      label: "Suspend",
      id: "suspend",
      icon: "pi pi-pause-circle",
      command: () => this.suspend(this.activeItem!.id),
    },
    {
      label: "Activate",
      id: "activate",
      icon: "pi pi-play-circle",
      command: () => this.activate(this.activeItem!.id),
    },
    {
      label: "Cancel",
      id: "cancel",
      icon: "pi pi-times-circle",
      command: () => this.cancel(this.activeItem!.id),
    },
    {
      label: "Change Plan",
      id: "change_plan",
      icon: "pi pi-cart-plus",
      command: () => this.changePlanVisible.set(true),
    },
    {
      label: "Change Price",
      id: "change_price",
      icon: "pi pi-dollar",
      command: () => this.changePriceVisible.set(true),
    },
    {
      label: "Check balance",
      id: "check_balance",
      icon: "pi pi-dollar",
      command: () => this.checkBalance(this.activeItem!.id),
    },
  ];

  constructor(
    private customerService: CustomerService,
    protected router: Router,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {
    super();
    this.isLoading(true);
    this.cols.push({
      field: "first_name",
      header: "First Name",
      type: "text",
    } as Column);
    this.cols.push({
      field: "last_name",
      header: "Last Name",
      type: "text",
    } as Column);
    this.cols.push({
      field: "status",
      header: "Status",
      type: "text",
    } as Column);
    this.cols.push({
      field: "autopay_status",
      header: "Autopay",
      pipe: "boolToText",
      type: "boolean",
    } as Column);
    this.cols.push({
      field: "subscriptions_total",
      header: "Monthly $",
      type: "numeric",
    } as Column);
    this.cols.push({
      field: "current_balance",
      header: "Balance",
      type: "numeric",
    } as Column);
  }

  handleData(data: any) {
    this.customerService
      .getAllAsList()
      .then((result) => {
        if (result.status === FUNCTION_RESULT_STATUS.SUCCESS) {
          this.customers = result.data || []; // Safely handle undefined data
          this.setActiveTab("Active");
        } else {
          console.error("Failed to fetch customers:", result.status);
        }
      })
      .catch((error) => {
        console.error("Error fetching customers:", error);
      })
      .finally(() => {
        this.isLoading(false);
      });
  }

  rowSelected(event: any) {
    this.objectId.set(event.id!);
  }

  async checkBalance(id: string) {
    await this.customerService.refreshCustomerBalance(createObjectKey(id, id)).then(() => {
      this.handleData(true);
    })
  }
  menuClicked(rowData: ICustomerOverview) {
    console.log("Current status", this.activeItem?.status);
    this.activeItem = rowData;
    this.row_items = [];

    this.items.forEach((item) => {
      switch (item.id) {
        case "suspend":
          if (this.activeItem?.status == CUSTOMER_STATUS.ACTIVE) {
            this.row_items.push(item);
          }
          return item;
        case "activate":
          if (
            this.activeItem?.status == CUSTOMER_STATUS.SUSPENDED ||
            this.activeItem?.status == CUSTOMER_STATUS.LEAD ||
            this.activeItem?.status == CUSTOMER_STATUS.PENDING
          ) {
            this.row_items.push(item);
          }
          return item;
        case "cancel":
          if (
            this.activeItem?.status === CUSTOMER_STATUS.ACTIVE ||
            this.activeItem?.status === CUSTOMER_STATUS.INACTIVE ||
            this.activeItem?.status === CUSTOMER_STATUS.SUSPENDED ||
            this.activeItem?.status == CUSTOMER_STATUS.PENDING ||
            this.activeItem?.status == CUSTOMER_STATUS.LEAD 
          ) {
            this.row_items.push(item);
          }
          return item;
        case "change_price":
          if (
            this.activeItem?.status === CUSTOMER_STATUS.ACTIVE ||
            this.activeItem?.status === CUSTOMER_STATUS.SUSPENDED ||
            this.activeItem?.status === CUSTOMER_STATUS.LEAD ||
            this.activeItem?.status == CUSTOMER_STATUS.PENDING
          ) {
            this.row_items.push(item);
          }
          return item;
        case "change_plan":
          if (
            this.activeItem?.status === CUSTOMER_STATUS.ACTIVE ||
            this.activeItem?.status === CUSTOMER_STATUS.SUSPENDED ||
            this.activeItem?.status === CUSTOMER_STATUS.LEAD ||
            this.activeItem?.status == CUSTOMER_STATUS.PENDING
          ) {
            this.row_items.push(item);
          }
          return item;
        default:
          this.row_items.push(item);
          return item;
      }
    });
    this.objectId.set(rowData.id);
  }

  view(customer_id: string) {
    this.router.navigate(["/admin/customers/view/", customer_id]);
  }

  edit(customer_id: string) {
    this.router.navigate(["/admin/customers/edit/", customer_id]);
  }

  activate(customer_id: string) {
    this.confirmationService.confirm({
      target: event!.target as EventTarget,
      message: "Are you sure that you want to activate this customer?",
      header: "Activate Customer",
      closable: true,
      closeOnEscape: true,
      icon: "pi pi-exclamation-triangle",
      rejectButtonProps: {
        label: "Cancel",
        severity: "secondary",
        outlined: true,
      },
      acceptButtonProps: {
        label: "Activate Customer",
      },
      accept: async () => {
        //*************************************
        //TODO: add workflow to credit and debit customer account for plan change
        // */
        this.isLoading(true);

        await this.customerService
          .activate(customer_id)
          .then((result) => {
            if (result.status !== FUNCTION_RESULT_STATUS.SUCCESS) {
              this.messageService.add({
                severity: "error",
                summary: "Customer was not activated",
                detail: "Customer has not been changed",
                life: 3000,
              });
              this.isLoading(false);
              return Promise.reject(result);
            }

            this.messageService.add({
              severity: "success",
              summary: "Customer Activated",
              detail: "Customer has been activated successfully!",
              life: 3000,
            });
            this.isLoading(false);
            this.handleData(true);
            return Promise.resolve();
          })
          .catch((err) => {
            this.messageService.add({
              severity: "error",
              summary: "Customer Not Activated",
              detail: "Customer has not been activated",
              life: 3000,
            });
            this.isLoading(false);
            return Promise.reject(err);
          })
          .finally(() => {
            this.isLoading(false);
          });
      },
      reject: () => {
        this.isLoading(false);
      },
    });
  }

  suspend(customer_id: string) {
    this.confirmationService.confirm({
      target: event!.target as EventTarget,
      message: "Are you sure that you want to suspend this customer?",
      header: "Suspend Customer",
      closable: true,
      closeOnEscape: true,
      icon: "pi pi-exclamation-triangle",
      rejectButtonProps: {
        label: "Cancel",
        severity: "secondary",
        outlined: true,
      },
      acceptButtonProps: {
        label: "Suspend Customer",
      },
      accept: async () => {
        //*************************************
        //TODO: add workflow to credit and debit customer account for plan change
        // */
        this.isLoading(true);

        await this.customerService
          .suspend(customer_id)
          .then((result) => {
            if (result.status !== FUNCTION_RESULT_STATUS.SUCCESS) {
              this.messageService.add({
                severity: "error",
                summary: "Customer was not suspended",
                detail: "Customer has not been changed",
                life: 3000,
              });
              this.isLoading(false);
              return Promise.reject(result);
            }

            this.messageService.add({
              severity: "success",
              summary: "Customer Suspended",
              detail: "Customer has been suspended successfully!",
              life: 3000,
            });
            this.isLoading(false);
            this.handleData(true);
            return Promise.resolve();
          })
          .catch((err) => {
            this.messageService.add({
              severity: "error",
              summary: "Customer Not Suspended",
              detail: "Customer has not been suspended",
              life: 3000,
            });
            this.isLoading(false);
            return Promise.reject(err);
          })
          .finally(() => {
            this.isLoading(false);
          });
      },
      reject: () => {
        this.isLoading(false);
      },
    });
  }

  cancel(customer_id: string) {
    this.confirmationService.confirm({
      target: event!.target as EventTarget,
      message: "Are you sure that you want to delete this customer?",
      header: "Delete Customer",
      closable: true,
      closeOnEscape: true,
      icon: "pi pi-exclamation-triangle",
      rejectButtonProps: {
        label: "Cancel",
        severity: "secondary",
        outlined: true,
      },
      acceptButtonProps: {
        label: "Delete Customer",
      },
      accept: async () => {
        //*************************************
        //TODO: add workflow to credit and debit customer account for plan change
        // */
        this.isLoading(true);

        await this.customerService
          .cancel(customer_id)
          .then((result) => {
            if (result.status !== FUNCTION_RESULT_STATUS.SUCCESS) {
              this.messageService.add({
                severity: "error",
                summary: "Customer was not deleted",
                detail: "Customer has not been changed",
                life: 3000,
              });
              this.isLoading(false);
              return Promise.reject(result);
            }

            this.messageService.add({
              severity: "success",
              summary: "Customer Deleted",
              detail: "Customer has been deleted successfully!",
              life: 3000,
            });
            this.isLoading(false);
            this.handleData(true);
            return Promise.resolve();
          })
          .catch((err) => {
            this.messageService.add({
              severity: "error",
              summary: "Customer Not Deleted",
              detail: "Customer has not been deleted",
              life: 3000,
            });
            this.isLoading(false);
            return Promise.reject(err);
          })
          .finally(() => {
            this.isLoading(false);
          });
      },
      reject: () => {
        this.isLoading(false);
      },
    });
  }

  ngOnInit(): void {
    this.handleData(true);
  }
}
